import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const navLinks = document.querySelectorAll('nav a[href^="#"]');
    const sections = Array.from(navLinks).map(link => document.getElementById(link.getAttribute('href').substring(1))).filter(Boolean);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, { rootMargin: '-50% 0px -50% 0px' });

    sections.forEach(section => {
      if (section) observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-background/90 backdrop-blur-lg shadow-md py-3' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <a href="#home" className="flex items-center text-2xl font-bold text-primary">
          <img src="/logo1.png" alt="Logo" className="w-8 h-8 mr-2" />
          Thamodya Ranasinghe
        </a>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-foreground"
          onClick={toggleMenu}
        >
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu"><line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="6" x2="20" y2="6"></line><line x1="4" y1="18" x2="20" y2="18"></line></svg>
          )}
        </button>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex gap-6 items-center">
          <a href="#home" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'home' ? 'text-primary underline underline-offset-4' : ''}`}>Home</a>
          <a href="#about" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'about' ? 'text-primary underline underline-offset-4' : ''}`}>About</a>
          <a href="#skills" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'skills' ? 'text-primary underline underline-offset-4' : ''}`}>Skills</a>
          <a href="#services" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'services' ? 'text-primary underline underline-offset-4' : ''}`}>Services</a>
          <a href="#experiences" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'experiences' ? 'text-primary underline underline-offset-4' : ''}`}>Experiences</a>
          <a href="#works" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'works' ? 'text-primary underline underline-offset-4' : ''}`}>Works</a>
          <a href="#education" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'education' ? 'text-primary underline underline-offset-4' : ''}`}>Education</a>
          <a href="#contact" className={`text-foreground hover:text-primary transition-colors ${activeSection === 'contact' ? 'text-primary underline underline-offset-4' : ''}`}>Contact</a>
          {/* <Button asChild>
            <a href="#contact">Get In Touch</a>
          </Button> */}
        </nav>
        
        {/* Mobile Navigation */}
        <nav className={`fixed top-[60px] right-0 w-full bg-background/95 backdrop-blur-lg shadow-lg transition-transform duration-300 transform md:hidden ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="flex flex-col p-6 gap-4">
            <a href="#home" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'home' ? 'text-primary' : ''}`} onClick={toggleMenu}>Home</a>
            <a href="#about" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'about' ? 'text-primary' : ''}`} onClick={toggleMenu}>About</a>
            <a href="#skills" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'skills' ? 'text-primary' : ''}`} onClick={toggleMenu}>Skills</a>
            <a href="#services" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'services' ? 'text-primary' : ''}`} onClick={toggleMenu}>Services</a>
            <a href="#experiences" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'experiences' ? 'text-primary' : ''}`} onClick={toggleMenu}>Experiences</a>
            <a href="#education" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'education' ? 'text-primary' : ''}`} onClick={toggleMenu}>Education</a>
            <a href="#works" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'works' ? 'text-primary' : ''}`} onClick={toggleMenu}>Works</a>
            <a href="#contact" className={`text-foreground hover:text-primary py-2 border-b border-border ${activeSection === 'contact' ? 'text-primary' : ''}`} onClick={toggleMenu}>Contact</a>
            {/* <Button asChild className="mt-2">
              <a href="#contact" onClick={toggleMenu}>Get In Touch</a>
            </Button> */}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
